export const BizAppConfig = {
  // 应用名称
  appName: process.env.UMI_APP_APP_NAME,

  // 多语言应用名称
  appNames: {
    'zh-CN': process.env.UMI_APP_APP_NAME_ZH_CN,
    'zh-TW': process.env.UMI_APP_APP_NAME_ZH_TW,
    'en-US': process.env.UMI_APP_APP_NAME_EN_US,
    'ja-JP': process.env.UMI_APP_APP_NAME_JA_JP,
  },

  // 应用 logo
  appLogo: process.env.UMI_APP_APP_LOGO,

  // 底部版权
  appFooterCopyright: process.env.UMI_APP_APP_FOOTER_COPYRIGHT,

  // 多语言底部版权
  appFooterCopyrights: {
    'zh-CN': process.env.UMI_APP_APP_FOOTER_COPYRIGHT_ZH_CN,
    'zh-TW': process.env.UMI_APP_APP_FOOTER_COPYRIGHT_ZH_TW,
    'en-US': process.env.UMI_APP_APP_FOOTER_COPYRIGHT_EN_US,
    'ja-JP': process.env.UMI_APP_APP_FOOTER_COPYRIGHT_JA_JP,
  },

  // API 地址（由不同环境配置文件注入 UMI_APP_API_URL）
  appApiUrl: process.env.UMI_APP_API_URL,

  // ============ 新建应用需要修改！！！ ============
  // SSO 客户端ID（优先读取环境变量，否则用默认值）
  appSsoClientId: process.env.UMI_APP_SSO_CLIENT_ID,

  // SSO 授权地址
  appSsoAuthorizeUrl: process.env.UMI_APP_SSO_AUTHORIZE_URL,

  // SSO 登出地址
  appSsoLogoutUrl: process.env.UMI_APP_SSO_LOGOUT_URL,

  // 个人中心地址
  appPersonalCenterUrl: process.env.UMI_APP_PERSONAL_CENTER_URL,

  // 企业管理地址
  // 支持占位符：{tenantUuid}、{organizationUuid}
  appTenantManagementUrl: process.env.UMI_APP_TENANT_MANAGEMENT_URL,

  // 工作台地址
  appWorkbenchUrl: process.env.UMI_APP_WORKBENCH_URL,

  // 跨应用深链（各应用自身域名/本地端口，供本应用跳转到其它业务域）
  appInvestmentUrl: process.env.UMI_APP_INVESTMENT_APP_URL,
  appPortfolioUrl: process.env.UMI_APP_PORTFOLIO_APP_URL,
  appExitUrl: process.env.UMI_APP_EXIT_APP_URL,
  appFundUrl: process.env.UMI_APP_FUND_APP_URL,
  appResearchUrl: process.env.UMI_APP_RESEARCH_APP_URL,

  // zy-task：开放平台来源应用 UUID（写入任务 sourceAppUuid）
  taskSourceAppUuid: process.env.UMI_APP_TASK_SOURCE_APP_UUID,

  // zy-task：开放平台网关
  openPlatformGatewayBaseUrl:
    process.env.UMI_APP_OPEN_PLATFORM_GATEWAY_BASE_URL ||
    'https://open-api.zhiyueyun.com',
  openPlatformGatewayPath:
    process.env.UMI_APP_OPEN_PLATFORM_GATEWAY_PATH ?? 'api-gateway',

  // zy-task：本地直连任务后端（可选，仅联调）
  taskDirectBaseUrl: process.env.UMI_APP_TASK_DIRECT_BASE_URL,
};
